// Form di creazione nuovo cliente (privato o azienda) con contatti e indirizzo
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Separator } from '../../ui/separator';
import {
    Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../ui/select';

export const NewCustomerForm = ({
    newCustomerData, setNewCustomerData, savingCustomer, onSaveNewCustomer,
}) => (
    <div className="space-y-4">
        {/* Tipo cliente */}
        <div className="space-y-2">
            <Label>Tipo Cliente *</Label>
            <Select
                value={newCustomerData.tipo}
                onValueChange={(v) => setNewCustomerData({...newCustomerData, tipo: v})}
            >
                <SelectTrigger>
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="privato">Privato</SelectItem>
                    <SelectItem value="azienda">Azienda</SelectItem>
                </SelectContent>
            </Select>
        </div>

        {newCustomerData.tipo === 'privato' ? (
            /* Campi Privato */
            <div className="grid grid-cols-2 gap-3">
                <div className="space-y-2">
                    <Label>Nome *</Label>
                    <Input
                        value={newCustomerData.nome}
                        onChange={(e) => setNewCustomerData({...newCustomerData, nome: e.target.value})}
                        placeholder="Mario"
                    />
                </div>
                <div className="space-y-2">
                    <Label>Cognome *</Label>
                    <Input
                        value={newCustomerData.cognome}
                        onChange={(e) => setNewCustomerData({...newCustomerData, cognome: e.target.value})}
                        placeholder="Rossi"
                    />
                </div>
                <div className="col-span-2 space-y-2">
                    <Label>Codice Fiscale</Label>
                    <Input
                        value={newCustomerData.codice_fiscale}
                        onChange={(e) => setNewCustomerData({...newCustomerData, codice_fiscale: e.target.value.toUpperCase()})}
                        placeholder="RSSMRA80A01H501Z"
                        maxLength={16}
                    />
                </div>
            </div>
        ) : (
            /* Campi Azienda */
            <div className="space-y-3">
                <div className="space-y-2">
                    <Label>Ragione Sociale *</Label>
                    <Input
                        value={newCustomerData.ragione_sociale}
                        onChange={(e) => setNewCustomerData({...newCustomerData, ragione_sociale: e.target.value})}
                        placeholder="Azienda S.r.l."
                    />
                </div>
                <div className="space-y-2">
                    <Label>Partita IVA</Label>
                    <Input
                        value={newCustomerData.partita_iva}
                        onChange={(e) => setNewCustomerData({...newCustomerData, partita_iva: e.target.value})}
                        placeholder="12345678901"
                        maxLength={11}
                    />
                </div>
                <div className="grid grid-cols-2 gap-3">
                    <div className="space-y-2">
                        <Label>Referente</Label>
                        <Input
                            value={newCustomerData.nome}
                            onChange={(e) => setNewCustomerData({...newCustomerData, nome: e.target.value})}
                            placeholder="Nome"
                        />
                    </div>
                    <div className="space-y-2">
                        <Label>&nbsp;</Label>
                        <Input
                            value={newCustomerData.cognome}
                            onChange={(e) => setNewCustomerData({...newCustomerData, cognome: e.target.value})}
                            placeholder="Cognome"
                        />
                    </div>
                </div>
            </div>
        )}

        {/* Contatti - comune a entrambi */}
        <Separator />
        <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2">
                <Label>Email</Label>
                <Input
                    type="email"
                    value={newCustomerData.email}
                    onChange={(e) => setNewCustomerData({...newCustomerData, email: e.target.value})}
                    placeholder="email@example.com"
                />
            </div>
            <div className="space-y-2">
                <Label>Telefono</Label>
                <Input
                    value={newCustomerData.telefono}
                    onChange={(e) => setNewCustomerData({...newCustomerData, telefono: e.target.value})}
                    placeholder="+39 333 1234567"
                />
            </div>
        </div>

        {/* Indirizzo */}
        <div className="space-y-2">
            <Label>Indirizzo</Label>
            <Input
                value={newCustomerData.indirizzo}
                onChange={(e) => setNewCustomerData({...newCustomerData, indirizzo: e.target.value})}
                placeholder="Via Roma 123"
            />
        </div>
        <div className="grid grid-cols-3 gap-3">
            <div className="space-y-2">
                <Label>Città</Label>
                <Input
                    value={newCustomerData.citta}
                    onChange={(e) => setNewCustomerData({...newCustomerData, citta: e.target.value})}
                    placeholder="Milano"
                />
            </div>
            <div className="space-y-2">
                <Label>Prov.</Label>
                <Input
                    value={newCustomerData.provincia}
                    onChange={(e) => setNewCustomerData({...newCustomerData, provincia: e.target.value.toUpperCase()})}
                    placeholder="MI"
                    maxLength={2}
                />
            </div>
            <div className="space-y-2">
                <Label>CAP</Label>
                <Input
                    value={newCustomerData.cap}
                    onChange={(e) => setNewCustomerData({...newCustomerData, cap: e.target.value})}
                    placeholder="20100"
                    maxLength={5}
                />
            </div>
        </div>

        {/* Bottone salva */}
        <Button
            onClick={onSaveNewCustomer}
            disabled={savingCustomer}
            className="w-full"
            data-testid="save-new-customer-btn"
        >
            {savingCustomer ? 'Salvataggio...' : 'Crea e Associa Cliente'}
        </Button>
    </div>
);
